module.exports = __webpack_public_path__ + "img/10@2x.6a4b39c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/cooperation/10@2x.png
// module id = q6P+
// module chunks = 0